import { render, staticRenderFns } from "./ShowWarehouses.vue?vue&type=template&id=b795e7b8"
import script from "./ShowWarehouses.vue?vue&type=script&lang=js"
export * from "./ShowWarehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports